import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { Paginacao } from "app/components/itens-orcamento/paginacao/Paginacao";
import clsx from "clsx";
import { useFormik } from "formik";
import React, { useEffect, useRef } from "react";
import { InputCpfCnpj } from "../../inputs/InputCpfCnpj";
const estiloPesquisaFornecedor =
  require("./pesquisa-fornecedor.module.scss").default;

export type FiltroPesquisaFornecedor = {
  CnpjCpf: string;
  InscricaoEstadual: string;
  Nome: string;
  NumeroPagina: number;
  TamanhoPagina: number;
};

export type Fornecedor = {
  CnpjCpf: string;
  CpfCnpj: string;
  Codigo: number;
  CodigoFabricante: string;
  CodigoInterno: string;
  Comunicacoes: any;
  Enderecos: any;
  InscricaoEstadual: string;
  Nome: string;
  RazaoSocial: string;
  UserMessage: string;
  Transforming: boolean;
};

export type PesquisaFornecedorProps = {
  fornecedores: PagedMessageResponse<Fornecedor>;
  filtroPesquisaFornecedor: FiltroPesquisaFornecedor;
  onPesquisar: (filtroPesquisaFornecedor: FiltroPesquisaFornecedor) => void;
  onFornecedorSelecionado: (nomeFornecedor: string, codigoInterno: string) => void;
  onAlterarListaSelecionada: (numeroIndexPagina: number) => void;
};

const PesquisaFornecedor = (props: PesquisaFornecedorProps) => {
  const formik = useFormik({
    initialValues: { ...props.filtroPesquisaFornecedor },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
  });

  const nome = <div className={estiloPesquisaFornecedor.form}>
    <label>Nome</label>
    <input
      autoFocus
      name="Nome"
      id="Nome"
      type="text"
      maxLength={254}
      value={(formik.values?.Nome) ?? ""}
      onChange={formik.handleChange}
    />
  </div>

  const cnpjCpf = <div className={estiloPesquisaFornecedor.form}>
    <label>CNPJ / CPF</label>
    <InputCpfCnpj
      name="CnpjCpf"
      cpfCnpj={formik.values?.CnpjCpf}
      onCpfCnpjModificado={(novoCpfCnpj) =>
        formik.setFieldValue("CnpjCpf", novoCpfCnpj)
      }
    />
  </div>

  const inscricaoEstadual = <div className={estiloPesquisaFornecedor.form}>
    <label>Insc. Estadual</label>
    <input
      name="InscricaoEstadual"
      type="text"
      value={(formik.values?.InscricaoEstadual) ?? ""}
      onChange={formik.handleChange}
      maxLength={20}
    />
  </div>

  const botaoPesquisa = <div className={estiloPesquisaFornecedor.form}>
    <button
      className={estiloPesquisaFornecedor.botao}
      id="pesquisa-fornecedores"
      onClick={() => {
        props.onPesquisar(formik.values);
      }}
    >
      Pesquisa
    </button>
  </div>

  const tabela = props.fornecedores?.Entities?.length > 0 && (
    <div
      id="tabela-fornecedores"
      className={estiloPesquisaFornecedor.tabela}
    >
      <div>
        <div>Nome</div>
        <div>CNPJ / CPF</div>
        <div>Insc. Estadual</div>
      </div>

      {props.fornecedores?.Entities?.map((fornecedor) => {
        return (
          <div
            key={fornecedor.CnpjCpf}
            className={estiloPesquisaFornecedor.linha}
            onClick={() => props.onFornecedorSelecionado(fornecedor.Nome, fornecedor.CodigoInterno)}
          >
            <div>{fornecedor.Nome.toUpperCase()}</div>
            <div>{fornecedor.CnpjCpf}</div>
            <div>{fornecedor.InscricaoEstadual}</div>
          </div>
        );
      })}
    </div>
  )

  return (
    <>
      <form onSubmit={(e) => { e.preventDefault(); }}>
        <fieldset>
          {nome}
          {cnpjCpf}
          {inscricaoEstadual}
        </fieldset>
        {botaoPesquisa}
      </form>

      {tabela}
      <br />

      {props.fornecedores?.PageCount > 1 && (
        <Paginacao
          paginaAtual={props.fornecedores?.ActualPage}
          totalPaginas={props.fornecedores?.PageCount}
          id="PesquisaFornecedor_Paginacao"
          onAlterarListaSelecionada={props.onAlterarListaSelecionada}
        />
      )}

      <br />
      <br />
    </>
  );
};

export { PesquisaFornecedor };
